import { useState } from "react";
import { fetchPlanDetails } from "../pages/tatvaShots/service";
import useStore from "../store/useStore";

const usePlanDetails = () => {
  const { setPlanDetails } = useStore();
  const [planLoader, setPlanLoader] = useState(false);

  const getPlanDetails = async () => {
    setPlanLoader(true);
    const planDetails: any = await fetchPlanDetails();
    setPlanLoader(false);
    setPlanDetails({
      ...planDetails,
      isMedleyShotsPlan:
        planDetails?.shot_plan?.service_payer?.code === "MEDLEY",
      isMedleyAiPlan: planDetails?.ai_plan?.service_payer?.code === "MEDLEY",
      isSelfShotsPlan:
        planDetails?.shot_plan &&
        planDetails?.shot_plan?.service_payer?.code === "SELF",
      isSelfAiPlan:
        planDetails?.ai_plan &&
        planDetails?.ai_plan?.service_payer?.code === "SELF",
      isSelfRemotePlan:
        planDetails?.remote_plan &&
        planDetails?.remote_plan?.service_payer?.code === "SELF",
    });
  };

  return { getPlanDetails, planLoader };
};

export default usePlanDetails;
